<template>
    <v-dialog @keydown.esc="close()" v-model="dialog" persistent max-width="320px">
        <v-card>
            <v-container>
                <!-- <div class="modal__container__div--Btn">
                    <v-btn class="modal__container__btn__close" text @click="closeModal(false)">
                        <span class="modal__container__btn__close--span" :style="{'color': currentCompany.buttonsColor }" > x </span>                    
                    </v-btn>
                </div> -->
                <v-card-title id="vdialog_vcard_info" class="flex-row-center no-pd-l no-pd-r">
                    Você confirma o resgate de:
                </v-card-title>
                <v-card-text class="no-pd flex-col-center">
                    <span id="vdialog_vcard_info" class="">{{confirmationObject.value}}</span>
                    <span id="vdialog_vcard_info" class="vdialog_vcard_cardtext__rendeem">{{confirmationObject.pointsToRedeem}}</span>
                </v-card-text>
                <v-card-actions class="flex-row-center">
                    <v-btn  class="text-none" :color="currentCompany.buttonsColor" :loading="btnLoading" @click="sendConfirmationRescue()"> <span style="color: var(--cor--branco)">Sim</span> </v-btn>
                    <v-btn  class="text-none" outlined :color="currentCompany.buttonsColor" @click="close()">Não</v-btn>
                </v-card-actions>
            </v-container>            
        </v-card>
    </v-dialog>
</template>

<script>
//Store
import { mapGetters, mapActions } from "vuex";

//Services
import { updateAvailableOfferRedemptionByIdAndCompanyIdAndCurrentContactId } from "@/app/modals/rescue-confirmation-modal/service/rescue-confimation-modal.service"

export default {
    name: 'RescueConfirmation',
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        confirmObject: {
            type: Object
        }
    },
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'   
            }
        )
    },
    data: () => ({
        confirmationObject: {},
        //controle
        btnLoading: false
    }),
    watch: {
        confirmObject: {
            deep: true,
            handler() {
                setConfirmationObject(this.confirmObject)
            }
        }
    },
    created() {
        this.setConfirmationObject(this.confirmObject)
    },
    methods: {
        ...mapActions('authenticateStore', ['SET_REMAINING_POINTS']),
        setConfirmationObject(confirmingInfo) {
            var stringDynamic = confirmingInfo.pointsToRedeem  <= 1 ? ' ponto?' : ' pontos?'
            this.confirmationObject.pointsToRedeem = 'por ' + confirmingInfo.pointsToRedeem + stringDynamic

            if( confirmingInfo.discountPercent == null && confirmingInfo.discountValue == null ) {
                this.confirmationObject.value = confirmingInfo.name
            }
            if( confirmingInfo.discountPercent !== null && confirmingInfo.discountValue == null ) {
                this.confirmationObject.value = 'Vale compras ' + confirmingInfo.discountPercent + '%'
            }
            if( confirmingInfo.discountPercent == null && confirmingInfo.discountValue !== null ) {
                var stringDiscountValue = confirmingInfo.discountValue.toString() 
                stringDiscountValue.indexOf('.') == -1 ? this.confirmationObject.value = 'Vale compras R$' + confirmingInfo.discountValue + '.00' : this.confirmationObject.value = 'Vale compras R$' + confirmingInfo.discountValue + '0'
            }
        },
        sendConfirmationRescue() {
            this.btnLoading = true
            updateAvailableOfferRedemptionByIdAndCompanyIdAndCurrentContactId(this.currentCompany.id, this.confirmObject.id )
                .then( () => {
                        var currentRemainingPoints = this.currentCompany.remainingPoints - this.confirmObject.pointsToRedeem
                        this.SET_REMAINING_POINTS(currentRemainingPoints)
                        this.$toasted.show('Resgatado com sucesso.', { type: 'success' })                        
                        this.btnLoading = false
                        this.close()
                    }
                )
                .catch( error => {
                        this.btnLoading = false
                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },

        close() {
            if(!this.btnLoading) {
                this.$emit("closeConfirmModal", false);
            }
        },

    }
}
</script>

<style scoped>
::v-deep .v-dialog {
    border-radius: 12px;
}
::v-deep .v-progress-circular {
    color: white;
}
#vdialog_vcard_info {
    font-weight: 800;
    font-size: 14px !important;
    color: var(--cor--preta)
}
.vdialog_vcard_cardtext__rendeem {
    padding-bottom: 6px;
}
</style>